webpackJsonp([68],{

/***/ "/MmQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-background-text_c4a28c7484115fc9e7573956afede14c.html";

/***/ }),

/***/ "bep0":
/***/ (function(module, exports, __webpack_require__) {

var SectionBackgroundText = (function () {
    function SectionBackgroundText() {
    }
    return SectionBackgroundText;
}());
angular.module('animatronApp.sectionBackgroundText', []).component('sectionBackgroundText', {
    bindings: {
        ltTitle: '<?',
        background: '<?',
        description: '<?',
    },
    controller: SectionBackgroundText,
    templateUrl: __webpack_require__("/MmQ")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/68-28dc41a6a889e793a2e2.min.js